module.exports = __webpack_public_path__ + "img/logo_black.e9ade65f.svg";